// material
import {
  Stack,
  Box,
  TextField,
  Autocomplete,
  Card,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Modal,
} from '@mui/material';
import { useState } from 'react';
import { get, isEmpty } from 'lodash';
// components
import Scrollbar from '../components/Scrollbar';
import Page from '../components/Page';

// store
import { api as stockApi } from '../store/domains/stock';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 1,
  p: 4,
  borderRadius: 2,
};
export default function Hierarchy() {
  const [partnerValue, setPartnerValue] = useState('');
  const [partnerId, setPartnerId] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [accessManagementModal, setAccessManagementModal] = useState({ isOpen: false, dealerId: null });
  const { data: posManagerOrganizations } = stockApi.useGetOrganizations(null);
  const { data: advancedFeatures } = stockApi.useGetAdvancedFeatures();
  const [removeAcess, { isLoading: removeLoading }] = stockApi.useRemoveAccess();
  const [giveAccess, { isLoading: giveLoading }] = stockApi.useGiveAcess();
  const [getAdvancedFeaturesByPartner, { data: advancedFeaturesByPartner, isFetching: byPartnerFetching }] =
    stockApi.useGetAdvancedFeaturesByPartner();

  const { data: partnerData } = stockApi.useGetOrganizationsTree(partnerId, {
    skip: !partnerId,
  });
  const handleChange = (value) => {
    setPartnerValue(value.label);
    setPartnerId(value.id);
  };

  const subOrganizations = get(partnerData, 'data.subOrganizations');
  const handleClose = () => {
    setAccessManagementModal((prevState) => ({ ...prevState, isOpen: false }));
  };
  const handleManageClick = (id) => {
    getAdvancedFeaturesByPartner(id)
      .unwrap()
      .then(() => {
        setAccessManagementModal({ isOpen: true, dealerId: id });
      });
  };
  const handleRemoveAccess = (id) => {
    removeAcess({ partnerId: accessManagementModal.dealerId, accessId: id })
      .unwrap()
      .catch(() => {
        handleClose();
      });
  };
  const handleGiveAccess = (id) => {
    giveAccess({ partnerId: accessManagementModal.dealerId, accessId: id })
      .unwrap()
      .catch(() => handleClose());
  };

  const renderAccessButton = (accessId) => {
    const haveAccess = (advancedFeaturesByPartner || []).find((item) => item.id === accessId);
    const isDisabled = removeLoading || giveLoading;
    return haveAccess ? (
      <Button disabled={isDisabled} color="success" onClick={() => handleRemoveAccess(accessId)}>
        Allowed
      </Button>
    ) : (
      <Button disabled={isDisabled} color="error" onClick={() => handleGiveAccess(accessId)}>
        Denied
      </Button>
    );
  };

  const renderTable = (data) => (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            {Object.entries(data)
              .filter(([, val]) => typeof val !== 'object')
              .map(([item], index) => (
                <TableCell key={index} align="left">
                  {item}
                </TableCell>
              ))}
            <TableCell align="left">Access</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.values(data)
            .filter((it) => typeof it !== 'object')
            .map((item, index) => (
              <TableCell key={index} align="left">
                {item}
              </TableCell>
            ))}
          <TableCell align="left">
            <Button variant="contained" disabled={byPartnerFetching} onClick={() => handleManageClick(data?.id)}>
              Manage
            </Button>
          </TableCell>
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderSubOrg = (subOrgs) => (
    <>
      <Typography variant="h3" color="green" padding={3}>
        Sub Dealer
      </Typography>
      {renderTable(subOrgs)}
    </>
  );

  return (
    <Page title="User">
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Stack sx={{ my: 2, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Box display="flex" sx={{ mx: 2 }}>
            <Autocomplete
              value={partnerValue}
              onChange={(_, newValue) => {
                handleChange(newValue);
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              options={posManagerOrganizations || []}
              sx={{ width: 300 }}
              renderInput={(params) => <TextField {...params} label="Select Partner" />}
            />
          </Box>
        </Stack>
      </Stack>
      {partnerData && (
        <Card>
          <Scrollbar>
            <Typography variant="h2" color="green" padding={3}>
              Dealer
            </Typography>
            {renderTable(partnerData?.data)}

            {!isEmpty(subOrganizations) && <>{subOrganizations?.map(renderSubOrg)}</>}
          </Scrollbar>
        </Card>
      )}
      <Modal
        open={accessManagementModal.isOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Module name</TableCell>
                  <TableCell align="left">Access</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {advancedFeatures &&
                  advancedFeatures.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.module}</TableCell>
                      <TableCell> {renderAccessButton(item.id)}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
    </Page>
  );
}
